module.exports = __webpack_public_path__ + "static/media/Radiant.492b625f.jpg";